<template>
    <div class="container">
        <div class="spinner"></div>
    </div>
</template>

<script>
import { getRefreshToken } from '@/auth/authStore'
import { setCookies } from '@/utils'
import { jwtDecode } from 'jwt-decode'

export default {
    name: 'AuthHandler',
    mounted() {
        const hash = window.location.hash;
        // remove leading "#/" or "#"
        const queryString = hash.replace(/^#\/?/, "");

        const urlParams = new URLSearchParams(queryString)
        //const urlParams = new URLSearchParams(window.location.search)
        const session = urlParams.get("session")
        const token = urlParams.get("token")
        const version = urlParams.get("version")
        this.init("streetlight", session, token, version, "/auth/login", "/V2/totalsolution", "/home")
    },
    methods: {
        async init(service, session, token, version, login_route, home_route, redirect_route) {
            if (!token || !session) {
                window.location.href = login_route
                console.log("invalid session")
                return
            }

            let decoded
            try {
                decoded = jwtDecode(token)
            } catch (error) {
                console.error(`jwt decode error: ${error.message || error}`)
                window.location.href = login_route
                return
            }

            let { ShortName } = decoded
            if (ShortName !== service) {
                const res = await getRefreshToken(service, session)
                if (!res) {
                    console.log("forbidden")
                    window.location.href = login_route
                    return
                }
                session = res.session
                token = res.token
                decoded = jwtDecode(res.token)
            }

            const userRole = decoded.UserTypeID === 1 ? 'vectolabs' : 'tenant'
            localStorage.setItem('user', userRole)
            setCookies('token', token)
            setCookies('session', session)
            setCookies('username', decoded.Name)
            setCookies('user', userRole)
            if (decoded.TenantID) {
                setCookies('tenantID', decoded.TenantID)
            }

            if (version === "2") {
                window.location.href = redirect_route
                return
            }
            window.location.href = home_route
        }
    }
}
</script>


<style scoped>
.container {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffffff;
}

.spinner {
    width: 40px;
    height: 40px;
    border: 4px solid #ccc;
    border-top-color: #007bff;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
</style>
